import { ComponentFactoryResolver, ComponentRef, Injectable } from '@angular/core';

@Injectable()
export class SnapshotScorecardService {
  private componentRef: ComponentRef<any>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  createComponent(component: any, directive: any): ComponentRef<any> {
    const componentInstance = component;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentInstance);
    const viewContainerRef = directive.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = viewContainerRef.createComponent(componentFactory);
    return this.componentRef;
  }
}
